const initialState = {
    loading:false,
    userInfo:null,
    token:null,
    error:null
}

const userReducer = (state = initialState, action ) => {
    switch (action.type){
        case 'USER_REGISTER_REQUEST':
        case 'USER_LOGIN_REQUEST':
            return {...state, loading:true, error: null };

        case 'USER_REGISTER_SUCCESS':            
        case 'USER_LOGIN_SUCCESS':
            return {...state, loading:false, userInfo:action.payload.user, token:action.payload.token, error: null };

        case 'USER_REGISTER_FAIL':
        case 'USER_LOGIN_FAIL':
            return {...state, loading:false, error: action.payload };
        
        case 'USER_LOGOUT':
            return {...state, userInfo: null, token: null, error: null };
        case 'OAUTH_TOKEN_VALIDATION_REQUEST' :
            return {...state, loading: true, error: null };
        case 'OAUTH_TOKEN_VALIDATION_SUCCESS' :
            return {...state, loading: false, error: null };
        case 'OAUTH_TOKEN_VALIDATION_FAIL' :
            return {...state, loading: false, error: action.payload };
        case 'OAUTH_SESSION_EXTENSION_REQUEST' :
            return {...state, loading: true, error: null };
        case 'OAUTH_SESSION_EXTENSION_SUCCESS' :
            return {...state, loading: false, error: null };
        case 'OAUTH_SESSION_EXTENSION_FAIL' :
            return {...state, loading: false, error: action.payload };
        default:
            return state;
    }
}

export default userReducer;